<script>
    export let value = 100;
    export let min = 0;
    export let max = 1000;
    export let step = 1;
    export let sensitivity = 1;
    export let suffix = '';
    export let decimals = 0;

    // let dragging = false;
    // $: value_ = value ? value.toFixed(decimals) : value;

    function startDrag(_) {
        // dragging = true;
    }

    function stopDrag(_) {
        // if (dragging) {
        //     console.log(value_);
        //     value = +value_;
        // }
        // dragging = false;
    }

    function drag(event) {
        // if (dragging) {
        //     value_ = Math.min(
        //         Math.max(
        //             value_ + Math.round(event.movementX * sensitivity) * step,
        //             min
        //         ),
        //         max
        //     );
        // }
    }
</script>

<svelte:body on:mouseup={stopDrag} on:mousemove={drag} />

<span class="no-select" on:mousedown={startDrag}>
    <input
        type="number"
        bind:value
        {min}
        {max}
        {step}
        style={`width:${Math.floor(Math.log10(value)) + 5}ch;`}
    />{suffix}
</span>

<style>
    span {
        cursor: pointer;
        box-shadow: 0px 1px #ddd;
    }
    input {
        flex-shrink: 1;
    }
</style>
